import React from "react";
import TermsOfUseContent from "./TermsOfUseContent";
import { Container } from "@mui/material";
import { Title } from "./TermsOfUse.styled";

const TermsOfUse = () => {
  return (
    <Container sx={{ padding: "50px 0" }}>
      <Title variant="h1">Terms Of Use</Title>
      <TermsOfUseContent />
    </Container>
  );
};

export default TermsOfUse;
